export interface ActivityScheduleDraft {
  dealId?: string | null;
  leadId?: string | null;
  companyId?: string | null;
  ownerId?: string | null;
  activityTypeKey?: string | null;
  scheduledFor?: Date | null;
}

type Listener = (draft: ActivityScheduleDraft) => void;

let listener: Listener | null = null;

export function registerActivityScheduleListener(next: Listener | null) {
  listener = next;
}

export function requestActivityScheduleDraft(draft: ActivityScheduleDraft) {
  listener?.(draft);
}
